import { useMediaQuery, Box, Drawer, useTheme } from '@mui/material';
import SidebarItems from './SidebarItems';
import Logo from '../../shared/logo/Logo.ico';
import { useSelector, useDispatch } from 'react-redux';
import { hoverSidebar, toggleMobileSidebar } from 'src/store/customizer/CustomizerSlice';
import Scrollbar from 'src/components/custom-scroll/Scrollbar';
import { Profile } from './SidebarProfile/Profile';
import Brand from 'src/assets/main-brand/fullMainLogo.png';
import BrandWhite from 'src/assets/main-brand/fullMainLogoWhite.png';
import SmallLogoBrand from 'src/assets/main-brand/vedanta-logo.png';
const Sidebar = () => {
  const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const customizer = useSelector((state) => state.customizer);
  const dispatch = useDispatch();
  const theme = useTheme();
  const defaultMainLogo = customizer.activeMode === 'dark' ? BrandWhite : Brand;
  const defaultShortLogo = SmallLogoBrand;
  const toggleWidth =
    customizer.isCollapse && !customizer.isSidebarHover
      ? customizer.MiniSidebarWidth
      : customizer.SidebarWidth;

  const onHoverEnter = () => {
    if (customizer.isCollapse) {
      dispatch(hoverSidebar(true));
    }
  };

  const onHoverLeave = () => {
    dispatch(hoverSidebar(false));
  };

  const decideLogo = () => {
    if (customizer.isSidebarHover) {
      // return customizer.activeMode === 'light' ? SpicLogo : SpicWLogo;
      const mainLogo = defaultMainLogo;
      return mainLogo;
    } else {
      // return customizer.activeMode === 'light' ? SLogo : SWLogo;
      const shortLogo = defaultShortLogo;
      return shortLogo;
    }
  };

  if (lgUp) {
    return (
      <Box
        sx={{
          width: toggleWidth,
          flexShrink: 0,
          ...(customizer.isCollapse && {
            position: 'absolute',
          }),
        }}
      >
        {/* ------------------------------------------- */}
        {/* Sidebar for desktop */}
        {/* ------------------------------------------- */}
        <Drawer
          anchor="left"
          open
          onMouseEnter={onHoverEnter}
          onMouseLeave={onHoverLeave}
          variant="permanent"
          PaperProps={{
            sx: {
              transition: theme.transitions.create('width', {
                duration: theme.transitions.duration.shortest,
              }),
              width: toggleWidth,
              boxSizing: 'border-box',
            },
          }}
        >
          {/* ------------------------------------------- */}
          {/* Sidebar Box */}
          {/* ------------------------------------------- */}
          <Box
            sx={{
              backgroundColor:
                customizer.activeMode === 'dark' ? customizer.darkBackground900 : '#FFF2D7',
              color: customizer.activeSidebarBg === '#FFF2D7' ? '' : '#FFF2D7',
              height: '100%',
            }}
          >
            {/* ------------------------------------------- */}
            {/* Logo */}
            {/* ------------------------------------------- */}
            {customizer.isCollapse ? (
              <Box px={3} display="flex" justifyContent="center">
                <img
                  // src={`${BaseURL}/${decideLogo()}`}
                  src={`${decideLogo()}`}
                  alt="Vedanta logo"
                  style={{
                    // width: customizer.isSidebarHover ? '100%' : '40px',
                    width: '100%',
                    height: 'auto',
                    marginTop: '20px',
                  }}
                />
              </Box>
            ) : (
              <Box px={3} display="flex" justifyContent="center">
                <img
                  // src={customizer.activeMode === 'light' ? SpicLogo : SpicWLogo} // Original logos when sidebar is not collapsed
                  src={`${defaultMainLogo}`}
                  alt="Vedanta"
                  width="100%"
                  style={{ marginTop: '20px' }}
                />
              </Box>
            )}
            <Scrollbar sx={{ height: 'calc(100% - 190px)' }}>
              {/* ------------------------------------------- */}
              {/* Sidebar Items */}
              {/* ------------------------------------------- */}
              <SidebarItems />
            </Scrollbar>
            <Profile />
          </Box>
        </Drawer>
      </Box>
    );
  }

  return (
    <Drawer
      anchor="left"
      open={customizer.isMobileSidebar}
      onClose={() => dispatch(toggleMobileSidebar())}
      variant="temporary"
      PaperProps={{
        sx: {
          width: customizer.SidebarWidth,
          backgroundColor:
            customizer.activeMode === 'dark'
              ? customizer.darkBackground900
              : customizer.activeSidebarBg,
          color: customizer.activeSidebarBg === '#ffffff' ? '' : 'white',
          border: '0 !important',
          boxShadow: (theme) => theme.shadows[8],
        },
      }}
    >
      {/* ------------------------------------------- */}
      {/* Logo */}
      {/* ------------------------------------------- */}
      <Box px={2}>
        <img src={Brand} alt="Logo" width="90%" />
      </Box>
      {/* ------------------------------------------- */}
      {/* Sidebar For Mobile */}
      {/* ------------------------------------------- */}
      <SidebarItems />
    </Drawer>
  );
};

export default Sidebar;
